import React, { useState, useEffect } from "react";
import { useLoaderData } from "react-router-dom";
import _ from 'lodash';
import Tooltip from 'components/Tooltip';
import * as Cart from 'hooks/cart';
import { PurchasedTogether, GreenCircleCheck } from "../../components/icons";

const CartPage = () => {
  const state = useLoaderData();
  const {
    cart, user, useCartLoggerEnabled, Bugfender
  } = state;
  const [revealedPricingIndices, setRevealedPricingIndices] = useState({ 0: [], 1: [] });
  const [banksSelectedLengths, setBanksSelectedLengths] = useState({});
  const { useCrossSell } = Cart;

  const crossSellsFor = bank => _.reverse(_.sortBy(bank.products, 'duration'));
  const handleCrossSellPriceSelection = (bankId, product) => setBanksSelectedLengths(prev => ({ ...prev, [bankId]: product }));

  useCrossSell(cart, setRevealedPricingIndices, handleCrossSellPriceSelection, crossSellsFor);

  useEffect(() => {
    if (useCartLoggerEnabled) {
      if (!user.signed_in) {
        if (useCartLoggerEnabled) {
          Bugfender.setDeviceKey('user_id', -1);
        }
        return;
      }
      Bugfender.setDeviceKey('email', user.data.email);
      Bugfender.setDeviceKey('user_id', user.data.id);
    }
  }, [user]);

  const banksAvailableForTier = function (num) {
    const latestPrimary = cart.mostRecentPrimaryCartItem();
    if (_.isUndefined(latestPrimary)) { return false; }

    const crossSells = latestPrimary.product.crossSellsForTier(num);

    return _.some(_.reject(crossSells, function(bank) {
      return cart.includesAnyProduct(bank.products);
    }));
  };

  const crossSellPriceFor = function (product, tier) {
    const discount = cart.mostRecentPrimaryCartItem().discountForTier(tier);
    return product.priceWithPercentDiscount(discount);
  };

  const totalPriceFor = function (bank, tier) {
    if (!banksSelectedLengths[bank.id]) { return null; }
    let price = crossSellPriceFor(banksSelectedLengths[bank.id], tier);
    if (bank.includesCme) { price += bank.adjustedCmePrice(); }
    return price;
  };

  const cmeEligible = function(bank) {
    return (parseInt(bank.cme_hours) > 0);
  };

  const cmeBlurbFor = function(bank) {
    const creditType = bank.alternative_cme_hour_type === "Contact Hours" ? 'CE' : 'CME';
    if (!bank.selectedLength) {
      return `Include ${creditType} Certificate for as low as $${bank.cmeAddOn.price - bank.cmeDiscountAmount}`;
    }
    return `${creditType} Certificate: $${bank.adjustedCmePrice()}`;
  };

  const tooltipInfoFor = function(bank) {
    const creditType = bank.alternative_cme_hour_type === "Contact Hours" ? 'CE' : 'CME';
    let string = `Earn ${creditType} simultaneously as you study`;
    if (bank.alternative_cme_hour_type !== "Contact Hours") {
      string = string + "\n<span class='small'>" + bank.cme_hours
       + " AMA Category 1 Credits</span>";
    }

    if (bank.alternative_cme_hours) {
      string = string + "\n<span class='small'>" + bank.alternative_cme_hours
                        + " " + bank.alternative_cme_hour_type + "</span>";
    }

    if (bank.cmeAddOn) {
      string = string + "\n$" + (bank.cmeAddOn.price - bank.cmeDiscountAmount)
               + "\n<span class='red'>Save $" + bank.cmeDiscountAmount + " when purchased with either the Master or Prepare plan</span>";
    }

    return string;
  };

  const crossSell = ({ banks, tier, index }) => banks.map((bank, subIndex) => {
    const bankId = bank?.id;
    return (bank ? (
      <div className="recommendations flex" key={bankId}>
        <div className="recommendation">
          <span className="badge-sale">{`${cart.mostRecentPrimaryCartItem().discountForTier(tier)} % OFF`}</span>
          <h3>{bank.name}</h3>
          <p>{bank.count_specifications_rendered}</p>
          <p>{bank.brief_marketing_blurb}</p>
        </div>
        {(!revealedPricingIndices[index] || revealedPricingIndices[index].lastIndexOf(subIndex) === -1) ? (
          <div className={`discount index-${index}`}>
            <div className="triangle" />
            <button type="button" className="btn btn-dark" onClick={() => setRevealedPricingIndices({ ...revealedPricingIndices, [index]: [...revealedPricingIndices[index], subIndex] })}>Show Discounts</button>
          </div>
        ) : (
          <form method="post" action="/cart_items" data-remote="true" className="plan-pricings">
            <p>Select your plan</p>
            <input type="hidden" name="cart_item[primary_cart_item_id]" value={cart.mostRecentPrimaryCartItem().id} />
            <input type="hidden" name="cross_sell_item" value="true" />
            <ul>
              {crossSellsFor(bank).map(product => (
                // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-noninteractive-tabindex
                <li tabIndex={0} className={`plan cross-sell-product ${cart.descriptorForDuration(product.duration).title}`} key={product.id} onKeyDown={(e) => { if (e.key === 'Enter') { document.getElementById(`product-${product.id}`).click(); handleCrossSellPriceSelection(bankId, product); } }}>
                  <input type="radio" id={`product-${product.id}`} name="cart_item[product_id]" className="hidden" value={product.id} defaultChecked={cart.includesAnyProduct([product])} />
                  {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                  <label htmlFor={`product-${product.id}`} onKeyDown={() => handleCrossSellPriceSelection(bankId, product)} onClick={() => handleCrossSellPriceSelection(bankId, product)}>
                    <h4>{cart.descriptorForDuration(product.duration).title}</h4>
                    <p className="align-center">{cart.descriptorForDuration(product.duration).length}</p>
                    <span className="price-original">${product.price}</span>
                    <span className="price-actual">${crossSellPriceFor(product, tier)}</span>
                  </label>
                </li>
              ))}
            </ul>
            {cmeEligible(bank) ? (
              <div className="mobile-box">
                <div className="cme-container">
                  <input
                    tabIndex={0}
                    id={`cme-for-bank-${bankId}`}
                    name="cart_item[add_cme]"
                    type="checkbox"
                    className="cme-checkbox"
                    disabled={!banksSelectedLengths[bank.id]}
                    defaultChecked={cart.includesProductId(bank.cme_add_on.id)}
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.click(); } }}
                  />
                  <label htmlFor={`cme-for-bank-${bank.id}`}>
                    { cmeBlurbFor(bank) }
                  </label>
                  <Tooltip>
                    <p dangerouslySetInnerHTML={{ __html: tooltipInfoFor(bank) }} />
                  </Tooltip>
                </div>
              </div>
            ) : null}
            <div className="cart-info">
              {banksSelectedLengths[bank.id] ? <p>{`$${totalPriceFor(bank, tier)}`}</p> : null}
              <div className="input-container">
                <input type="submit" className="btn btn-orange add-to-cart" value="Add to Cart" />
              </div>
            </div>
          </form>
        )}
      </div>
    ) : null);
  });

  const h2Text = tier => (tier === 1 ? `Recommended with ${cart.mostRecentPrimaryCartItem().product.displayName}` : "Customers Who Bought This Also Bought");

  const crossSellList = (
    <div id="cross_sell_component">
      {[1, 2].map((tier, index) =>
        banksAvailableForTier(tier)
        && (
          <div className={`cross-sell tier-${tier}`} key={index}>
            <PurchasedTogether className="badge-together" />
            <span className="capitalize">{`Save ${cart.mostRecentPrimaryCartItem().discountForTier(tier)}% When Purchased Together`}</span>
            <h2>{h2Text(tier)}</h2>
            {crossSell({ banks: cart.mostRecentPrimaryCartItemAndAddons()[0].product.crossSellsForTier(tier), tier, index })}
          </div>
        ))}
    </div>
  );

  const cartItems = cart.mostRecentPrimaryCartItemAndAddons().map(item => (
    <li className="cart-item" key={item.id}>
      <div className="item-name">{item.displayName}</div>
      <div className="pull-right">
        {item.isDiscounted()
          ? (
            <>
              <span className="price actual">${item.discountedPrice()}</span>
              <span className="price original">${item.price}</span>
            </>
          )
          : <span className="price">${item.price}</span>}
      </div>
    </li>
  ));

  return (
    <div>
      <div className="cart wrapper" id="cart_items">
        <div className="cart-summary-wrapper">
          {cart.ready ? (
            <div className="container">
              <div className="added">
                <GreenCircleCheck />
                <span className="circle-check-slider" />
                <h1>Added to Cart</h1>
              </div>
              <div className="xsell-cart flex">
                <ul className="cart-items">
                  {cartItems}
                </ul>
                <div className="xsell-total">
                  <span className="pull-left">Cart Total ({cart.items.length} items): ${cart.total()}</span>
                  <span className="pull-left" />
                  <a className="pull-right btn btn-orange" href="/checkout">Proceed to Checkout</a>
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <div className="container">
          { !cart.containsStudentPurchase() && crossSellList }
        </div>
      </div>
    </div>
  );
};

export default CartPage;
